import * as THREE from 'three'
import Experience from '../Experience.js'
import Environment from './Environment.js'
import Background from './Background.js'
import PresetCards from './PresetCards.js'
import AudioAnalyser from './AudioAnalyser.js'
import ParticleSystem from './ParticleSystem.js'
import VideoExporter from './VideoExporter.js'

export default class World {
    constructor() {
        this.experience = new Experience()
        this.scene      = this.experience.scene
        this.resources  = this.experience.resources

        this.audioAnalyser  = new AudioAnalyser()
        this.particleSystem = new ParticleSystem()
        this.videoExporter  = new VideoExporter()

        this.resources.on('ready', () => {
            this.environment = new Environment()
            this.background  = new Background()

            // Defer PresetCards until #presets nears the viewport.
            // gl.compileShader × 10 + gl.linkProgram × 5 blocks the main thread for ~5s on mobile GPU
            // if run immediately — freezing the hero animation and delaying first paint.
            const presetsEl = document.getElementById('presets')
            const initCards = () => { this.presetCards = new PresetCards() }

            if (!presetsEl) { initCards(); return }

            const obs = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) { obs.disconnect(); initCards() }
            }, { rootMargin: '400px' })
            obs.observe(presetsEl)
        })
    }

    update() {
        this.audioAnalyser  && this.audioAnalyser.update()
        this.particleSystem && this.particleSystem.update()
        this.background     && this.background.update()
        this.presetCards    && this.presetCards.update()
    }

    destroy() {
        this.particleSystem?.destroy()
        this.background?.destroy()
        this.environment?.destroy()
    }
}
